import React from 'react';
import { connect } from 'react-redux';

// components
import Queuing from '../components/Queuing.js'
import ServiceWaitingTimes from '../components/queuing/content/ServiceWaitingTimes'
import SlaBreachedTickets from '../components/queuing/content/SlaBreachedTickets'
import { isSupervisorUser } from '../store/helpers';
import '../assets/css/Supervisor.css';

class Supervisor extends React.Component {
    render(){
        const { authenticatedUser, featureFlags } = this.props;
        const canViewSupervisorPage = featureFlags.slaBreach && isSupervisorUser(authenticatedUser);
        const content = canViewSupervisorPage
            ? <div className="supervisorPage">
                <div className="supervisorPageHeader">
                    <div>
                        <h2>Supervisor</h2>
                        <p>Live service activity</p>
                    </div>
                </div>
                <div className="supervisorPageStack">
                    <SlaBreachedTickets />
                    <ServiceWaitingTimes />
                </div>
            </div>
            : <div className="col-one" style={{width:500}}>
                <div className="home-left-content3-wraper">
                    <div className="home-left-content3">
                        <div className="titleBlock">
                            <h4>Supervisor Page</h4>
                        </div>
                        <div style={{ color: '#787D8B', fontSize: 16, lineHeight: 1.5 }}>
                            Page for supervisors only.
                        </div>
                    </div>
                </div>
            </div>
        return <Queuing children={content} />
    }
}

const mapStateToProps = state => ({
    authenticatedUser: state.auth.authenticatedUser,
    featureFlags: state.auth.featureFlags || { slaBreach: false },
});

export default connect(mapStateToProps, {})(Supervisor);
